export default "__VITE_ASSET__BYtbR4YR__"